import React from "react";
import "./OutcomePackages.scss";

const packages = [
  {
    number: "01",
    title: "AI Strategy Sprint",
    duration: "1 \u2013 3 weeks",
    desc:
      "A focused engagement for leaders who need a clear AI and technology roadmap, target architecture and delivery priorities.",
    output: [
      "AI opportunity and roadmap",
      "Architecture direction",
      "Delivery sequencing",
      "Investment clarity",
    ],
  },
  {
    number: "02",
    title: "AI Readiness & Technology Audit",
    duration: "1 \u2013 4 weeks",
    desc:
      "An independent review of your current stack, operating model and readiness to adopt AI or modernise critical systems.",
    output: [
      "Readiness assessment",
      "Risk and gap summary",
      "Technology audit findings",
      "Remediation roadmap",
    ],
  },
  {
    number: "03",
    title: "Cloud Posture & FinOps Review",
    duration: "3 days \u2013 2 weeks",
    desc:
      "We assess your cloud security posture, identify cost leaks, review governance controls and surface quick wins. Designed for engineering leaders and CFOs who want control, not just visibility.",
    output: [
      "Security posture report",
      "Cost optimisation recommendations",
      "Governance gap summary",
    ],
  },
  {
    number: "04",
    title: "Technical Health Check",
    duration: "3 days \u2013 2 weeks",
    desc:
      "A code and architecture review that identifies delivery bottlenecks, stability risks, technical debt and systemic vulnerabilities. Built for CTOs inheriting a platform, or boards conducting pre-investment diligence.",
    output: [
      "Architecture & codebase assessment",
      "Risk register",
      "Prioritised remediation brief",
    ],
  },
  {
    number: "05",
    title: "MMP Launchpad",
    duration: "4 \u2013 12 weeks",
    desc:
      "From scope freeze to live product. We design, build and launch a Minimally Marketable Product with full architectural governance, AI-accelerated delivery and senior oversight throughout.",
    output: ["Scope freeze", "Architecture design", "Built & launched MMP"],
    featured: true,
  },
  {
    number: "06",
    title: "AI & SaaS Product Engineering",
    duration: "6 \u2013 16 weeks",
    desc:
      "For founders, product leaders and engineering teams building the next generation of software. We design and deliver cloud-native SaaS platforms and AI-integrated products \u2014 structured under our CAB model so every build is governed, scalable and production-ready from day one.",
    output: [
      "Product architecture blueprint",
      "Cloud-native SaaS build",
      "AI feature integration",
      "Governed delivery to production",
    ],
  },
];

const ArrowIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 8h10M9 4l4 4-4 4" />
  </svg>
);

const IconCheck = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="2 8 6 12 14 4" />
  </svg>
);

const OutcomePackages = () => {
  return (
    <section className="pkg">
      <div className="pkg__mobile">
        <div className="pkg__mobile-header">
          <span className="pkg__label">Outcome Packages</span>
          <h2 className="pkg__title">Structured Engagements.</h2>
          <p className="pkg__subtitle">
            Each engagement has a clear deliverable, a fixed commercial boundary
            and an outcome you can act on.
          </p>
        </div>
        <div className="pkg__mobile-grid">
          {packages.map((pkg, i) => (
            <div
              key={i}
              className={`pkg__card${
                pkg.featured ? " pkg__card--featured" : ""
              }`}
            >
              {pkg.featured && <span className="pkg__card-badge">Popular</span>}
              <div className="pkg__card-meta">
                <span className="pkg__card-dur">{pkg.duration}</span>
              </div>
              <h3 className="pkg__card-title">{pkg.title}</h3>
              <p className="pkg__card-desc">{pkg.desc}</p>
              <ul className="pkg__card-deliverables">
                {pkg.output.map((item, j) => (
                  <li key={j}>
                    <span className="pkg__card-check">
                      <IconCheck />
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <a href="/contact-us" className="pkg__cta-card">
            <span className="pkg__cta-card-eyebrow">Ready to engage?</span>
            <strong className="pkg__cta-card-title">
              Explore All Engagement Options
            </strong>
            <p className="pkg__cta-card-sub">
              Fixed scope. Senior-led delivery. A defined next step in 30
              minutes.
            </p>
            <span className="pkg__cta-card-btn">
              Book a Strategy Call <ArrowIcon />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default OutcomePackages;
